module.exports = __webpack_public_path__ + "assets/img/d968fec9360836ba1fe4d2582010d060.png";